export const blockIconsUiactionsAddNew = (
	<span className='material-symbols-outlined'>add</span>
);
